import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageWeightComponent } from './manage-weight.component';

const routes: Routes = [
  { path: '', component: ManageWeightComponent, data: { title: 'Postcode Weighting' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageWeightRoutingModule {}

@NgModule({
  imports: [
    ManageWeightRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ManageWeightComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageWeightModule {}
